import React from "react";
import {
  Create,
  required,
  SimpleForm,
  TextInput,
  TopToolbar,
  ReferenceInput,
  SelectInput,
} from "react-admin";

import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

const Actions = ({ onCancel }) => (
  <TopToolbar>
    <IconButton onClick={onCancel}>
      <CloseIcon />
    </IconButton>
  </TopToolbar>
);

const ProfessionCreate = (props) => (
  <Create title=" " {...props} actions={<Actions {...props} />}>
    <SimpleForm redirect={props.basePath} variant="outlined">
      <TextInput source="name" fullWidth validate={required()} />
      <ReferenceInput source="riskLevelId" reference="risk-levels" fullWidth>
        <SelectInput optionText="name" validate={required()} />
      </ReferenceInput>
    </SimpleForm>
  </Create>
);

export default ProfessionCreate;
